import { isTravelTypeWithHousing } from '@repo/utils'
import React from 'react'

import s from './styles.module.scss'

import QuoteSection from './quote-section/QuoteSection'
import { HostBasketClientRequestFragment } from '../../../../../lib/graphql'
import {
  CurrencyAreaContextProvider,
  useTravelTypeContext,
} from '../../../../contexts'
import { IProposalInteractionsProps } from '../../../../organisms/proposal/Proposal'
import { CompanyInformation } from '../../../client-request-cart'
import { IUploadQuotationProps } from '../../../client-request-cart/client-request-company-information/footer/owner-current-action/upload-quotation-modal/UploadQuotationModal'

const HostBasket = ({
  clientRequest,
  ownerActions,
  uploadQuotationData,
}: {
  clientRequest: HostBasketClientRequestFragment
  ownerActions: IProposalInteractionsProps['ownerActions']
  uploadQuotationData?: IUploadQuotationProps
}) => {
  const { travelType } = useTravelTypeContext()

  const entity = isTravelTypeWithHousing(travelType)
    ? clientRequest.clientProposal?.house
    : clientRequest.clientProposal?.serviceProvider

  if (!entity) {
    return null
  }

  return (
    <CurrencyAreaContextProvider
      context={{ currencyArea: entity.currencyArea }}
    >
      <div className={s.container}>
        <CompanyInformation
          clientRequest={clientRequest}
          ownerActions={ownerActions}
          uploadQuotationData={uploadQuotationData}
        />
        <QuoteSection
          clientRequest={clientRequest}
          ownerActions={ownerActions}
          uploadQuotationData={uploadQuotationData}
        />
      </div>
    </CurrencyAreaContextProvider>
  )
}

export default HostBasket
